import React from 'react';
import NewModal from '../../components/UI/Modal';
import Input from '../../components/UI/Input';
import ReusableMultiSelectDialog from '../../components/ReusableMultiSelectDialog';
import { useSelector } from 'react-redux';
import { getUsers, getOffices } from '../../actions';

const OfficeOwnerFormModal = ({ show, handleClose, onSubmit, currentId, formItem, setFormItem }) => {
    const { users } = useSelector((state) => state.user);
    const { offices } = useSelector((state) => state.office);

    const handleOwnerSubmit = () => {
        return Promise.resolve();
    };

    return (
        <NewModal
            show={show}
            handleClose={handleClose}
            modalTitle={currentId ? 'Редактировать владельца' : 'Добавить владельца'}
            onSubmit={onSubmit}
            currentId={currentId}
            disabledSubmit={!formItem.userId}
        >
            <Input
                type="select"
                label="Пользователь"
                value={formItem.userId}
                placeholder="Выберите пользователя"
                onChange={(e) => setFormItem({ ...formItem, userId: e.target.value })}
                options={users.map((u) => ({
                    value: u._id,
                    name: `${u.firstName} ${u.lastName} (${u.email})`,
                }))}
            />
            <ReusableMultiSelectDialog
                type="office"
                title="Выберите офисы"
                description="Выберите офисы, которыми будет управлять владелец"
                data={offices}
                selectedValues={formItem.offices}
                setSelectedValues={(values) => setFormItem({ ...formItem, offices: values })}
                onSubmit={handleOwnerSubmit}
                fetchData={getOffices}
                buttonText="Выбрать офисы"
                inputLabelText="офисы"
            />
        </NewModal>
    );
};

export default OfficeOwnerFormModal;